import { Reports } from '../generated/Reports';
import { Lessons } from '../generated/Lessons';
import { ReportAttachment } from '../generated/ReportAttachment';
import { ReportComments } from '../generated/ReportComments';
import { BasicStrengthDTO } from './BasicStrengthDTO';
import { BasicStrengthCSVDTO } from './BasicStrengthCSVDTO';
import { PlanTarget } from '../generated/PlanTarget';

export class ReportAndFile extends ReportComments {
  urls?: string[];
  nickName?: string;
}
export class ReportDTO {
  lessons = new Lessons();
  studentNickname?: string;
  teacherNickname?: string;
  lesson_movie_save_url?: string;
  report: Reports = new Reports();
  attaches: ReportAttachment[] = [];
  comments: ReportAndFile[] = [new ReportAndFile()];
  strength: BasicStrengthDTO[] = [];
  strengthLinner: BasicStrengthCSVDTO = new BasicStrengthCSVDTO();
  plan_target: PlanTarget[] = [];
  isLocked = false;
  uploadFirstFiles: string[] = [];
  newComment = '';
}
